var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"radio-border-container"},[_c('span',{staticClass:"radio-border radio-border__hz radio-border__top"}),_c('span',{staticClass:"radio-border radio-border__vt radio-border__right"}),_c('span',{staticClass:"radio-border radio-border__hz radio-border__bottom"}),_c('span',{staticClass:"radio-border radio-border__vt radio-border__left"})])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80dac480","hasScoped":false,"optionsId":"0","buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RadioBorder.vue
// module id = null
// module chunks = 